import React from "react"

export const formatSize = (bytes) => {
  if (bytes == null) return "-";
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(1)} MB`;
}

export const fileBadge = (mime = "", fileName = "") => {
  const m = String(mime || "").toLowerCase();

  let last = String(fileName || "");
  try { last = new URL(last).pathname; } catch { }
  const ext = (last.split(".").pop() || "").toLowerCase();

  const VIDEO_EXT = new Set(["mp4", "mov", "webm", "wmv"]);
  const VIDEO_MIME_MAP = {
    "video/mp4": "MP4",
    "video/quicktime": "MOV",
    "video/webm": "WEBM",
    "video/x-ms-wmv": "WMV",
  };

  const IMG_EXT = new Set(["png", "jpg", "jpeg", "webp", "svg"]);
  const DOC_EXT = new Set(["doc", "docx"]);
  const XLS_EXT = new Set(["xls", "xlsx", "csv"]);
  const PPT_EXT = new Set(["ppt", "pptx"]);

  if (m.includes("pdf") || ext === "pdf") return badge("PDF");

  if (VIDEO_EXT.has(ext)) return badge(ext.toUpperCase());
  if (VIDEO_MIME_MAP[m]) return badge(VIDEO_MIME_MAP[m]);
  if (m.startsWith("video/")) return badge("VIDEO");

  if (m.includes("word") || DOC_EXT.has(ext)) return badge("DOCX");

  if (m.includes("sheet") || XLS_EXT.has(ext)) return badge("XLSX");

  if (m.includes("presentation") || PPT_EXT.has(ext)) return badge("PPTX");

  if (m.includes("zip") || ext === "zip") return badge("ZIP");

  if (m.startsWith("image/") || IMG_EXT.has(ext)) return badge("IMG");

  return badge("FILE");
};

const badge = (text) => (
  <span className="badge bg-light text-dark border" style={{ fontWeight: 600 }}>
    {text}
  </span>
);

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString();
  } catch {
    return iso;
  }
}

export const formatTime = (seconds) => {
  if (seconds === undefined || seconds === null || isNaN(seconds)) return "";

  const s = Math.max(0, Math.floor(seconds));
  const hrs = Math.floor(s / 3600);
  const mins = Math.floor((s % 3600) / 60);
  const secs = s % 60;

  if (hrs >= 1) {
    return `${hrs}:${String(mins).padStart(2, "0")} hour min`;
  }

  const mm = String(mins).padStart(2, "0");
  const ss = String(secs).padStart(2, "0");

  return mins === 0 ? `${mm}:${ss} sec` : `${mm}:${ss} min sec`;
};


export const truncate = (str, len = 13) => {
  if (!str) return "";
  return str.length > len ? str.substring(0, len) + "..." : str;
}

export const DATE_PRESETS = [
  { key: "last7", label: "Last 7 days" },
  { key: "last14", label: "Last 14 days" },
  { key: "last30", label: "Last 30 days" },
  { key: "thisMonth", label: "This month" },
  { key: "lastMonth", label: "Last month" },
  { key: "ytd", label: "Year to date" },
  { key: "custom", label: "Custom range…" },
  { key: "clear", label: "Clear" },
];


